// **  Initial State
const initialState = {
	data: {},
	loading: false
}

export const inspectionsReducer = (state = initialState, action) => {
	switch (action.type) {
		case 'INSPECTIONS_INFO_LOADING_START':
			return {
				...state, loading: true
			}
		case 'INSPECTIONS_INFO_LOADING_END':
			return {
				...state, loading: false
			}
		default:
			return state
	}
}
